import NXForm from './NXForm';

export default NXForm;
